import { ERP } from '../_base/endpoint';
import axios from 'axios';
import global from '../../common/utility/global';

class planCuentaService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarCuentaContable() {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/cuenta-contable`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async listarCuentaContableId(data) {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/contable?${global.formatParameter(data)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorMayorGrado(data) {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/mayor-grado?${global.formatParameter(data)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async listarTipoCuenta() {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/tipo-cuenta`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarTipoAnalisis() {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/tipo-analisis`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/plan-cuenta/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/plan-cuenta`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/plan-cuenta`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}administracion/plan-cuenta/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}administracion/plan-cuenta/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new planCuentaService();